import React, { useEffect } from 'react';
import { CRAFT_ELEMENTS } from '../config/craftElements';
import { ActionsController } from './ActionsController';

interface Props {
  html?: string;
  nodeId: string;
}

const HTMLWidget = ({ html, nodeId }: Props): React.ReactElement => {
  const htmlWidgetInnerWrapperId = `HTMLWidget-inner-${nodeId}`;

  useEffect(() => {
    if (html) {
      const fragment = document.createRange().createContextualFragment(html);
      const targetElement = document.getElementById(htmlWidgetInnerWrapperId);
      if (targetElement) {
        targetElement.innerHTML = '';
        targetElement.appendChild(fragment);
      }
    }
  }, [html]);

  return (
    <ActionsController>
      <div id={htmlWidgetInnerWrapperId}></div>
    </ActionsController>
  );
};

export default HTMLWidget;

const HTMLWidgetDefaultProps = {
  html: `<h1><b>Hello World..!</b></h1>
  <p>Hier kannst du deinen eigenen Code hinterlegen.</p>
  <script>
      var docReady = function(fn) {
          var stateCheck = setInterval(function() {
              if (document.readyState !== "complete") return;
              clearInterval(stateCheck);
              try {
                  fn()
              } catch (e) {}
          }, 1);
      };
      docReady(function() {
          console.log('HELLO WORLD!');
      });
  </script>`,
};

HTMLWidget.craft = {
  name: CRAFT_ELEMENTS.HTML_WIDGET,
  props: HTMLWidgetDefaultProps,
};
